import React from 'react';

import useCDNUrl from '../../../hooks/useCDNUrl.js';
import RIQButton from '../../../components/RIQButton.jsx';

import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

export default function InstantSearchUpsellWidget() {
    const emptyListeningUrl = useCDNUrl('/images/listening-empty2.svg');

    const plan = useCurationConfigValue('plan');
    const isTrial = plan.kind === 'trial';

    const headlineText = (isTrial ? 'Save, monitor, and compare your saved searches with Engage or Engage Pro.' : 'Upgrade now to save, monitor, and compare your saved searches.');

    function onClick() {
        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedListeningUpsell, {
            source: 'results-dashboard'
        });

        window.location.href = '/manage#subscription';
    }

    return (
        <div className='tlw-mb-10 tlw-flex tlw-flex-col tlw-rounded tlw-bg-white tlw-shadow-panel '>
            <div className='tlw-grid tlw-grid-cols-1 tlw-p-8 md_tlw-grid-cols-2'>
                <img
                    className='tlw-m-auto tlw-max-h-[180px]'
                    alt='error'
                    src={emptyListeningUrl}
                />
                <div className='tlw-my-10 tlw-grid tlw-justify-center tlw-text-md'>
                    <h2 className='tlw-mb-2 tlw-ml-4 tlw-text-lg'>{headlineText}</h2>
                    <ul className='tlw-my-7 tlw-list-outside'>
                        <li>Analyze brand perceptions and key sentiment drivers</li>
                        <li>Spot conversation spikes with always-on alerting</li>
                        <li>Identify online advocates and top sources for conversations about your brand</li>
                        <li>30 days of history</li>
                    </ul>
                    <div>
                        <RIQButton
                            className='tlw-mx-4 tlw-px-6 tlw-py-3'
                            variant='primary'
                            onClick={onClick}
                        >
                            Compare plans
                        </RIQButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
